export default __webpack_public_path__ + "static/media/help-center.35ce5926.svg";